<template lang="pug">
v-card.dashboard-list-panel
  v-card-title.dashboard-list-panel__title {{ title }}
  v-card-text.dashboard-list-panel__body
    .dashboard-list-panel__shell
      v-row(no-gutters)
        v-col(
          v-for="(column, columnIndex) in itemColumns",
          :key="columnIndex",
          class="dashboard-list-panel__column",
          cols="12",
          :sm="columnSpan"
        )
          ul.dashboard-list-panel__list
            li.dashboard-list-panel__item(
              v-for="item in column",
              :key="item.label",
              :class="{ 'dashboard-list-panel__item--link': item.key != null }",
              @click="handleItemClick(item)"
            )
              span.dashboard-list-panel__marker
              span.dashboard-list-panel__label-wrapper
                span.dashboard-list-panel__label {{ item.label }}
              span.dashboard-list-panel__badge {{ formatValue(item.value) }}
</template>

<script>
export default {
  name: "ListPanel",
  props: {
    title: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Number,
      default: 2,
      validator: value => [1, 2].includes(value)
    }
  },
  computed: {
    columnSpan() {
      return this.columns === 1 ? 12 : 6;
    },
    sortedItems() {
      return this.items
        .filter(item => Number(item?.value) > 0)
        .sort((a, b) =>
          String(a.label).localeCompare(String(b.label), "pt-BR", { sensitivity: "base" })
        );
    },
    itemColumns() {
      if (this.columns === 1) {
        return [this.sortedItems];
      }

      const midpoint = Math.ceil(this.sortedItems.length / 2);

      return [this.sortedItems.slice(0, midpoint), this.sortedItems.slice(midpoint)];
    }
  },
  methods: {
    formatValue(value) {
      return new Intl.NumberFormat("pt-BR").format(value || 0);
    },
    handleItemClick(item) {
      if (item?.key != null) {
        this.$emit("item-click", item.key);
      }
    }
  }
};
</script>

<style scoped>
.dashboard-list-panel {
  width: 100%;
  min-height: 316px;
  height: 316px;
  max-height: 316px;
  display: flex;
  flex-direction: column;
  border: 1px solid #d9e2ef !important;
  border-radius: 18px 6px 18px 6px !important;
  box-shadow: 0 2px 6px rgba(15, 42, 77, 0.08) !important;
}

.dashboard-list-panel__title {
  padding: 16px 16px 6px;
  color: #0a1f44;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
  word-break: normal;
}

.dashboard-list-panel__body {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 6px 14px 14px !important;
}

.dashboard-list-panel__shell {
  flex: 1 1 auto;
  min-height: 0;
  padding: 10px 12px;
  border: 1px solid #d9e3ef;
  border-radius: 10px;
  overflow-y: auto;
  scrollbar-width: thin;
}

.dashboard-list-panel__column {
  display: flex;
}

.dashboard-list-panel__list {
  flex: 1 1 auto;
  margin: 0;
  padding: 0 12px 0 0;
  list-style: none;
}

.dashboard-list-panel__item {
  display: flex;
  align-items: center;
  min-height: 36px;
  padding: 6px 0;
  gap: 10px;
  border-bottom: 1px solid #eef3f9;
}

.dashboard-list-panel__item:last-child {
  border-bottom: 0;
}

.dashboard-list-panel__item--link {
  cursor: pointer;
}

.dashboard-list-panel__item--link:hover .dashboard-list-panel__label,
.dashboard-list-panel__item--link:focus-visible .dashboard-list-panel__label {
  color: #3d82f6;
  text-decoration: underline;
}

.dashboard-list-panel__marker {
  flex: 0 0 6px;
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background-color: #9aaec9;
}

.dashboard-list-panel__label-wrapper {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
}

.dashboard-list-panel__label {
  display: block;
  color: #31496b;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  word-break: break-word;
  transition: color 0.18s ease;
}

.dashboard-list-panel__badge {
  flex: 0 0 auto;
  align-self: center;
  min-width: 32px;
  padding: 3px 9px;
  border-radius: 999px;
  background-color: #eef2f9;
  color: #5f6b7a;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  text-align: center;
}

@media (max-width: 959px) {
  .dashboard-list-panel {
    min-height: auto;
    height: auto;
    max-height: none;
  }

  .dashboard-list-panel__body {
    padding: 6px 12px 12px !important;
  }

  .dashboard-list-panel__list {
    padding-right: 0;
  }

  .dashboard-list-panel__item {
    min-height: 40px;
  }
}
</style>
